import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { storyblokEditable } from '@storyblok/react';
import React, { memo } from 'react';
import { withBaseComponent } from '../hoc/withBaseComponent';

const variants = [
  '',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
  'subtitle1',
  'subtitle2',
  'body1',
  'body2',
  'button',
  'caption',
  'overline',
  'small',
  'tiny',
];

/**
 * @param {object} props
 * @param {object} props.blok
 * @param {object} props.baseStyles
 */
const StoryblokTitleComponent = ({ blok, baseStyles }) => {
  const {
    general = {
      title: '',
      subtitle: '',
      textAlign: 'left',
      variant: {},
      component: {},
    },
    extra = { id: '' },
  } = blok;
  const { id } = extra;
  const {
    title,
    subtitle,
    textAlign,
    variant = {
      title: 'h1',
      subtitle: 'body1',
    },
    component = {
      title: null,
      subtitle: null,
    },
  } = general;
  const { title: titleVariant, subtitle: subtitleVariant } = variant;

  const anchor = title.replace(/\s+/g, '-').toLowerCase();

  return (
    <Box
      id={id}
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Box {...storyblokEditable(blok)} sx={{ ...baseStyles }}>
        <Typography
          id={anchor}
          textAlign={textAlign}
          variant={titleVariant}
          {...(component.title ? { component: component.title } : {})}
          gutterBottom
        >
          {title}
        </Typography>
        {subtitle ? (
          <Typography
            textAlign={textAlign}
            variant={subtitleVariant}
            {...(component.subtitle ? { component: component.subtitle } : {})}
          >
            {subtitle}
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
};

StoryblokTitleComponent.displayName = 'StoryblokTitle';
const StoryblokTitle = withBaseComponent(StoryblokTitleComponent);

export default memo(StoryblokTitle);
